// Imports ------------------------------------------------------------------->

import {Service, service, inject} from "./di";
import {SearchService} from "../services/SearchService";
import {EcomItemMediaObj, EcomItemSpecObj, EcomItemReviewsObj} from "../definitions/BackflippDefinitions";
import {Backflipp} from "./BackflippService";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

export class EcomItem {
	id: number;
	global_id: string;
	global_id_int: number;
	name: string;
	brand: string;
	description: string;
	media: EcomItemMediaObj[];
	size: string;
	url: string;
	colour: string;
	googleCategories: string[];
	merchantCategories: string[];
	specs: EcomItemSpecObj[];
	features: {
		text: string;
	}[];
	nutritionalInfo: string[];
	reviewSamples: EcomItemReviewsObj[];
	language: string;
	country: string;
	modelNumber: string;
	uniqueId: string;
	sku: string;
	currentPrice: number;
	originalPrice: number;
	webId: string;
	buyOnline: boolean;
	buyInStore: boolean;
	shipToHome: boolean;
	shipToStore: boolean;
	merchant: string;
	merchantId: number;
	merchantLogo: string;
	expired: boolean;

	constructor(json: any) {

		this.id = json.ecom_item.id;
		this.global_id = json.ecom_item.global_id;
		this.global_id_int = json.ecom_item.global_id_int;
		this.name = json.ecom_item.name;
		this.brand = json.ecom_item.brand;
		this.description = json.ecom_item.description;
		this.media = json.ecom_item.media;
		this.size = json.ecom_item.size;
		this.url = json.ecom_item.url;
		this.colour = json.ecom_item.colour;
		this.googleCategories = json.ecom_item.google_categories;
		this.merchantCategories = json.ecom_item.merchant_categories;
		this.specs = json.ecom_item.specs;
		this.features = json.ecom_item.features;
		this.nutritionalInfo = json.ecom_item.nutritional_info;
		this.reviewSamples = json.ecom_item.review_samples;
		this.language = json.ecom_item.language;
		this.country = json.ecom_item.country;
		this.modelNumber = json.ecom_item.model_number;
		this.uniqueId = json.ecom_item.unique_id;
		this.sku = json.ecom_item.sku;
		this.currentPrice = json.ecom_item.current_price;
		this.originalPrice = json.ecom_item.original_price;
		this.webId = json.ecom_item.web_id;
		this.buyOnline = json.ecom_item.buy_online;
		this.buyInStore = json.ecom_item.buy_in_store;
		this.shipToHome = json.ecom_item.ship_to_home;
		this.shipToStore = json.ecom_item.ship_to_store;
		this.merchant = json.ecom_item.merchant;
		this.merchantId = json.ecom_item.merchant_id;
		this.merchantLogo = json.ecom_item.merchant_logo;
		this.expired = json.ecom_item.expired || false;
	}

	getName() {
		return this.name;
	}

	getExpired(): boolean {
		return this.expired;
	}
}

@service
export class EcomService extends Service {

	@inject searchService: SearchService;
	@inject backflipp: Backflipp;
	private _ecomItemCache: { [ecomItemGlobalId: string]: Promise<EcomItem> } = {};

	getEcomItem(globalId: string): Promise<EcomItem> {
		if (!this._ecomItemCache[globalId]) {
			this._ecomItemCache[globalId] =
					this.backflipp.getMultiEcomItems([globalId])
						.then((ecomItemJson) => {
							const item = ecomItemJson ? new EcomItem({ecom_item: ecomItemJson.ecom_items[0]}) : null;
							return item;
						});
		}

		return this._ecomItemCache[globalId];
	}
}
